import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { Col, Form, Radio, RadioChangeEvent, Row } from "antd";
import type { SourcingRequirementApplicationFormFields } from "../type";
import styles from "@/asserts/styles/formSection.module.less";
import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";

type Props = {
  editable: boolean;
  show: boolean;
};

export const MaterialStandardFields = ({ editable, show }: Props) => {
  const form = Form.useFormInstance<SourcingRequirementApplicationFormFields>();

  const standardChanged = Form.useWatch("standardChanged", form);

  const showNewStandardField = standardChanged === 0;

  const onStandardChange = (e: RadioChangeEvent) => {
    form.setFieldValue("newStandardFiles", null);
  };

  if (!show) return null;

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title="物料标准确认" />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col>
            <Form.Item<SourcingRequirementApplicationFormFields>
              name="standardChanged"
              label="现有物料标准是否可用于寻源"
              layout="horizontal"
              rules={[
                {
                  required: true,
                  message: "请选择现有物料标准是否可用于寻源",
                },
              ]}
            >
              <Radio.Group
                disabled={!editable}
                options={[
                  { value: 1, label: "是" },
                  { value: 0, label: "否" },
                ]}
                onChange={onStandardChange}
              />
            </Form.Item>
          </Col>
        </Row>
        {showNewStandardField && (
          <Row>
            <MaterialFileFormFields<SourcingRequirementApplicationFormFields>
              fieldName="newStandardFiles"
              label="新标准物料文件"
              isCustomDisabled={true}
              disabled={!editable}
              hiddenRemove={!editable}
            />
          </Row>
        )}
      </div>
    </div>
  );
};
